"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var use_stores_1 = require("hooks/use-stores");
var TableHeading_1 = require("../common/table/TableHeading");
var utils_1 = require("../../util/utils");
var FilterBar_1 = __importDefault(require("../common/table/FilterBar"));
var Pager_1 = __importDefault(require("../common/table/Pager"));
var OrdersTable_1 = __importDefault(require("./OrdersTable"));
var Orders = mobx_react_1.observer(function () {
    var _a = use_stores_1.useStores(), prefsStore = _a.prefsStore, ordersStore = _a.ordersStore, orderPageStore = _a.orderPageStore;
    var _b = react_1.useState(false), transition = _b[0], setTransition = _b[1];
    var _c = react_1.useState(prefsStore.data.ordersTable.page - 1), offset = _c[0], setOffset = _c[1];
    var prefs = prefsStore.data.ordersTable;
    var transitionTimeout = react_1.useRef(null);
    react_1.useEffect(function () {
        document.title = 'Shop CMS - Orders';
        if (!ordersStore.data || ordersStore.data.length <= 0) {
            api_1.default.getShopOrders(offset + 1, prefs.perPage, (prefs.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefs.sort.name !== null ? prefs.sort.name : '-id'), prefs.search)
                .then(function (response) {
                ordersStore.setData(response.data.orders);
                orderPageStore.setData(response.data.page);
                prefsStore.editData({
                    ordersTable: __assign(__assign({}, prefs), { results: response.data.page.results })
                });
            })
                .catch(api_1.catchHandler);
        }
    }, []);
    var perPageHandler = function (value) {
        prefsStore.editData({
            ordersTable: __assign(__assign({}, prefs), { perPage: value })
        });
        api_1.default.getShopOrders(offset + 1, value, (prefs.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefs.sort.name !== null ? prefs.sort.name : '-id'), prefs.search)
            .then(function (response) {
            ordersStore.setData(response.data.orders);
            orderPageStore.setData(response.data.page);
        })
            .catch(api_1.catchHandler);
    };
    var searchHandler = function (value) {
        prefsStore.editData({
            ordersTable: __assign(__assign({}, prefs), { search: value })
        });
        clearTimeout(transitionTimeout.current);
        transitionTimeout.current = setTimeout(function () {
            api_1.default.getShopOrders(1, prefs.perPage, (prefs.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefs.sort.name !== null ? prefs.sort.name : '-id'), value)
                .then(function (response) {
                ordersStore.setData(response.data.orders);
                orderPageStore.setData(response.data.page);
            })
                .catch(api_1.catchHandler);
            if (ordersStore.data.length >= 0) {
                prefsStore.editData({
                    ordersTable: __assign(__assign({}, prefs), { page: 1, search: value })
                });
                setOffset(0);
            }
        }, 400);
    };
    var sortHandler = function (name, direction) {
        prefsStore.editData({
            ordersTable: __assign(__assign({}, prefs), { sort: {
                    name: name,
                    direction: direction
                } })
        });
        api_1.default.getShopOrders(offset + 1, prefs.perPage, (direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (name !== null ? name : '-id'), prefs.search)
            .then(function (response) {
            ordersStore.setData(response.data.orders);
            orderPageStore.setData(response.data.page);
        })
            .catch(api_1.catchHandler);
    };
    var pageHandler = function (page) {
        prefsStore.editData({
            ordersTable: __assign(__assign({}, prefs), { page: page + 1 })
        });
        var max = Math.ceil((orderPageStore.data === undefined ? prefsStore.data.ordersTable.results : orderPageStore.data.results) / prefs.perPage) - 1;
        if (page === offset)
            return;
        if (offset === max && page >= max)
            return;
        if (offset === 0 && page <= 0)
            return;
        //setTransition(true);
        clearTimeout(transitionTimeout.current);
        transitionTimeout.current = setTimeout(function () {
            setTransition(false);
            setOffset(utils_1.clamp(0, page, max));
        }, 200);
        api_1.default.getShopOrders(page + 1, prefs.perPage, (prefs.sort.direction === TableHeading_1.TableDirections.DOWN ? '-' : '') + (prefs.sort.name !== null ? prefs.sort.name : '-id'), prefs.search)
            .then(function (response) {
            ordersStore.setData(response.data.orders);
            orderPageStore.setData(response.data.page);
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement("div", { className: 'orders page', "data-transition": transition },
        react_1.default.createElement(FilterBar_1.default, { label: 'Orders', perPage: prefs.perPage, onPerPageChange: perPageHandler, searchValue: prefsStore.data.ordersTable.search, onSearchChange: searchHandler }),
        react_1.default.createElement(OrdersTable_1.default, { sort: prefs.sort, data: ordersStore.data, onChangeSort: sortHandler }),
        react_1.default.createElement(Pager_1.default, { itemsLength: orderPageStore.data === undefined ? prefsStore.data.ordersTable.results : orderPageStore.data.results, offset: offset, perPage: prefs.perPage, onPrev: function () { return pageHandler(offset - 1); }, onNext: function () { return pageHandler(offset + 1); }, onPage: pageHandler })));
});
exports.default = Orders;
